module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Traffic Forecast (7 days)","disclaimer":"Calculated by Flow AI for reference only"}}')
  delete Component.options._Ctor
}
